/**
 * Created by ganlu on 25/09/2016.
 */
import angular from 'angular';
import modalControl from './modal-control.directive';
import modalService from './modal.service';
import './modal.scss';

let modalModule = angular.module('modal', [])
    .directive('modalControl', modalControl)
    .service('modal', modalService)
    .name;

export default modalModule;



// WEBPACK FOOTER //
// ./src/app/common/modal/modal.js